import React from 'react';
import Vault from '../Vault';

export default function PasswordsApp() {
  return <Vault filterType="login" pageTitle="Password Vault" />;
}
